import React from "react";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";
import { Footer } from "../../../components/Footer";
import Logout from "../../../components/Logout";

function ManageAccountPage() {
  const { t } = useTranslation();
  const {search} = useLocation();
  const params = new URLSearchParams(search);
  const platform = params.get('platform');

  let manageSubscriptionText;
  let manageSubscriptionInstructions;

  switch (platform) {
    case 'android':
      manageSubscriptionText = (
        <>
          {t(`You’ve subscribed in the Google Play Store.`)}<br/><br/>{t(`Please manage your subscription from the`)} <a href="https://play.google.com/store/account/subscriptions?package=tv.skyship.supersimple">{t('App Store')}</a>.
        </>
      );
      manageSubscriptionInstructions = (
        <>
          <p>If there was an issue using the link above, here are the steps to manage your subscription on your device.</p>
          <ol>
            <li>On your mobile device, open the Google Play app</li>
            <li>Tap the profile icon</li>
            <li>Tap on Payments & Subscriptions, and then Subscriptions</li>
            <li>Select the subscription you want to manage</li>
            <li>From here you can manage your subscription</li>
          </ol>
        </>
      )
      break;
    case 'ios':
      manageSubscriptionText = (
        <>
          {t(`You’ve subscribed in the Apple App Store.`)}<br/><br/>{t(`Please manage your subscription from the`)} <a href="https://apps.apple.com/account/subscriptions">{t('App Store')}</a>.
        </>
      );
      manageSubscriptionInstructions = (
        <>
          <p>If there was an issue using the link above, here are the steps to manage your subscription on your device.</p>
          <ol>
            <li>On your mobile device, tap on your Settings app (the grey icon with the gears)</li>
            <li>Tap on Apple ID (at the top)</li>
            <li>Tap on Subscriptions</li>
            <li>Tap on Super Simple</li>
            <li>From here you can manage your subscription</li>
          </ol>
        </>
      )
      break;
    case 'amazon':
      manageSubscriptionText = (
        <>
          {t(`You’ve subscribed in the Amazon App Store.`)}<br/><br/>{t(`Please manage your subscription from the`)} <a href="https://www.amazon.com/your-account">{t('App Store')}</a>.
        </>
      );
      manageSubscriptionInstructions = (
        <>
          <p>If there was an issue using the link above, here are the steps to manage your subscription on your device.</p>
          <ol>
            <li>On the Amazon website, go to "Your Account"</li>
            <li>Select "Your Apps" under "Digital content and devices"</li>
            <li>Select "Your Subscriptions" under "Manage"</li>
            <li>Update your subcription as needed</li>
          </ol>
        </>
      )
      break;
    default:
      manageSubscriptionText = <></>;
      manageSubscriptionInstructions = <><p>Please manage your subscription from the app store where you subscribed.</p></>
  }

  return (
    <div className="main">
      <Logout />
      <div className="msd__header__logo"></div>
      <div className="choose-plan">
        <div className="manage-account-text">
          {manageSubscriptionText}
          <div className="manage-account-instructions">
            {manageSubscriptionInstructions}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ManageAccountPage;